//Imports node_modules
import React, { useContext } from "react"

//Imports Css
import './ButtonAdvanced.css'

//Imports Components

//Boão global 
import { globalFunctions } from '../../../data/GlobalFunctions'

//Este Botão foi principlamente feito para evitar duplo click, detetar micro deslizes de dedos, touch and click events
const ButtonAdvanced = (params) => {

    //--- Variaveis
    const {
        advancedClick
    } = useContext(globalFunctions);

    return (
        <button
            className={params.className ? params.className : ''}
            style={params.style ? params.style : {}}

            onClick={params.onClick ? (e => advancedClick(e, params.onClick)) : ''}
            onTouchStart={params.onClick ? (e => advancedClick(e, params.onClick)) : ''}
            onTouchEnd={params.onClick ? (e => advancedClick(e, params.onClick)) : ''}
            onMouseDown={params.onClick ? (e => advancedClick(e, params.onClick)) : ''}
            onMouseUp={params.onClick ? (e => advancedClick(e, params.onClick)) : ''}


            disabled={params.isDisabled ? params.isDisabled : false}>
            {params.children}
            {params.text}
        </button>
    )
}

export default ButtonAdvanced